import { useEffect, Component } from 'react';
import Lenis from 'lenis';
import { Toaster } from './components/ui/sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Services } from './components/Services';
import { InteriorBand } from './components/InteriorBand';
import { Showcase } from './components/Showcase';
import { Properties } from './components/Properties';
import { WhyInvicto } from './components/WhyInvicto';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-8 text-center">
          <p className="font-serif text-2xl text-espresso">Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-cream text-espresso">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <InteriorBand />
          <Showcase />
          <Properties />
          <WhyInvicto />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#FCFAF4',
              border: '1px solid rgba(158, 125, 86, 0.35)',
              color: '#2B241C',
            },
          }}
        />
      </div>
    </ErrorBoundary>
  );
}
